import { render, staticRenderFns } from "./ScheduleCardExample.vue?vue&type=template&id=5149649f"
import script from "./ScheduleCardExample.vue?vue&type=script&lang=ts"
export * from "./ScheduleCardExample.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports